import { Input, Show, TextArea } from "shared/components";
import { SectionCard } from "shared/app/SectionCard";
import { PropertyKind } from "shared/types";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { useAuthContext } from "providers/Auth";

interface UnitGeneralFormProps {
  register: any;
  headerExtra?: React.ReactNode;
  footer?: React.ReactNode;
  propertyKind?: PropertyKind | null;
  pmsId?: string;
}

export const UnitGeneralForm = (props: UnitGeneralFormProps) => {
  const { register, headerExtra, footer, propertyKind, pmsId } = props;
  const dictionary = useUnitsPropertiesDictionary();
  const { type } = useAuthContext();

  return (
    <SectionCard title="General" headerExtra={headerExtra} footer={footer}>
      <div className="divide-y divide-alpha-40">
        <div className="grid grid-cols-2 gap-4 py-4">
          <Tooltip>
            <TooltipTrigger className="w-full text-left">
              <Input
                id="title"
                label="Unit name"
                placeholder="Unit 1"
                {...register("title")}
                required
                readOnly={Boolean(pmsId)}
              />
            </TooltipTrigger>
            {pmsId && (
              <TooltipContent className="max-w-[320px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-white">
                {dictionary.Unit} name can only be edited within the PMS
              </TooltipContent>
            )}
          </Tooltip>
          <div>
            <Input
              id="externalId"
              label="Unit ID"
              placeholder="Unit 1"
              {...register("externalId")}
              readOnly={Boolean(pmsId)}
            />
          </div>
        </div>

        <Show if={propertyKind || type.isPmsListingSyncEnabled}>
          <div className="py-4">
            <TextArea
              id="description"
              label={
                <div className="flex items-center gap-1">
                  <p>Description</p>
                  <p className="text-sm font-medium text-content-100">
                    (Optional)
                  </p>
                </div>
              }
              placeholder="240"
              rows={4}
              autoExpand={true}
              readOnly={type.isPmsListingSyncEnabled}
              {...register("description")}
            />
          </div>
        </Show>
      </div>
    </SectionCard>
  );
};
